export default __webpack_public_path__ + "static/media/gap.49148221.svg";